import { DIVERSIFY_PORTFOLIO, DIVERSIFY_PORTFOLIO_ERROR, DIVERSIFY_PORTFOLIO_HIDE_ERROR, DIVERSIFY_PORTFOLIO_START_LOADER, DIVERSIFY_PORTFOLIO_STOP_LOADER, } from "../interface/IDiversifyPortfolio";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const DiversifyPortfolioReducer = (state = initState, action) => {
    switch (action.type) {
        case DIVERSIFY_PORTFOLIO: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case DIVERSIFY_PORTFOLIO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case DIVERSIFY_PORTFOLIO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case DIVERSIFY_PORTFOLIO_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case DIVERSIFY_PORTFOLIO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default DiversifyPortfolioReducer;
